const ActionTypes = {
    loading: "fetching",
    loaded: 'fetched',
    error: 'error'
};
export default ActionTypes;


// WEBPACK FOOTER //
// ./src/actions/status.action.js